import { useMutation, useQueryClient } from '@tanstack/react-query';

/* Keys & Apis */
import { cart } from '@api/apis';
import { cartQueryKeys } from './queries.keys';

/* Utils */
import { Logger } from '@utils/logger';

/* Types */
import { AddSkuStatePayload } from '@scenes/AddSkuPage/store/store.types';

type UseCartUpdateItemProps = {
  item: AddSkuStatePayload;
  email: string | null;
  index: number;
  manualCartToken?: string;
};

export default function useCartMutationUpdateitem() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ item, email, index, manualCartToken }: UseCartUpdateItemProps) => {
      const data = await cart.updateItem({ item, email, index: +index, ...(manualCartToken && { manualCartToken }) });
      if (data.status === 500) throw new Error(data.err);

      return data;
    },
    onSuccess: data => {
      const { cart: cartResponse = {} } = data?.data ?? {};

      /* Update cart */
      queryClient.setQueryData(cartQueryKeys.all, { ...cartResponse });
    },
    onError: error => {
      Logger('useCartMutationUpdateItem')(error as Error);
    },
  });
}
